<template>
    <DnButton
        v-bind="$attrs"
        class="sf-button"
    >
        <div
            v-if="!!$slots.pre"
            class="sf-button__pre"
        >
            <slot name="pre" />
        </div>

        <slot />

        <div
            v-if="!!$slots.after"
            class="sf-button__after"
        >
            <slot name="after" />
        </div>
    </DnButton>
</template>

<script setup>
import DnButton from '@digitalnatives/button';
</script>

<style src="./button.less" lang="less"></style>
